import { render, staticRenderFns } from "./ActiveCustomers.vue?vue&type=template&id=04f97b10&scoped=true&"
import script from "./ActiveCustomers.vue?vue&type=script&lang=js&"
export * from "./ActiveCustomers.vue?vue&type=script&lang=js&"
import style0 from "./ActiveCustomers.vue?vue&type=style&index=0&id=04f97b10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f97b10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VCol,VContainer,VDataTable,VRow,VTextField,VTooltip})
